import { useNavigate } from 'react-router';
import styled from 'styled-components';

import { AnimatedNumber } from 'atoms/animations/AnimatedNumber';
import { ButtonBase } from 'atoms/buttons/ButtonBase';
import { GemIcon } from 'atoms/icons/GemIcon';
import { Horizontal } from 'atoms/layout/flex';
import { LabelM } from 'atoms/typography';
import { ANY_SPORT_MARKET_COMMON_PACKS } from 'constants/__generated__/routes';
import { useSportContext } from 'contexts/sport';
import { useEvents } from 'lib/events/useEvents';
import { OpenBuyGemsDialog_Context } from 'protos/events/platform/web/events';

const IconWrapper = styled(Horizontal).attrs({ center: true })`
  width: var(--triple-unit);
  height: var(--triple-unit);
  border-radius: 50%;
  background: var(--c-nd-150);

  & > img {
    height: 16px;
    object-fit: contain;
  }
`;

const Root = styled(ButtonBase)`
  border-radius: var(--double-unit);
  padding-left: var(--unit);
  background: var(--c-nd-50);
  display: flex;
  &:hover {
    background: var(--c-nd-100);
  }
`;

type Props = { balance: number };
export const GemsBalance = ({ balance }: Props) => {
  const track = useEvents();
  const navigate = useNavigate();
  const { generateSportContextPath } = useSportContext();
  return (
    <Root
      onClick={() => {
        track('Open Buy Gems Dialog', {
          context: OpenBuyGemsDialog_Context.GEMS_BALANCE,
        });
        navigate(
          `${generateSportContextPath(ANY_SPORT_MARKET_COMMON_PACKS)}?buy_gems=true`
        );
      }}
    >
      <Horizontal gap={0.5}>
        <LabelM bold>
          <AnimatedNumber value={balance} disableAnimationOnFirstRender />
        </LabelM>
        <IconWrapper>
          <GemIcon />
        </IconWrapper>
      </Horizontal>
    </Root>
  );
};
